/**
 * Template: Products
 * -----------------------------------------------------------------------------
 * Used to import styles for all product templates.
 *
 */

 import ReviewsSection from '~/components/reviews-section'

 document.addEventListener('DOMContentLoaded', () => {
   ReviewsSection().init()
 })
